import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import emailjs from '@emailjs/browser';


class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      feedback: "",
      loading: false,
      success: false,
      error: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  
  handleSubmit(e){
    e.preventDefault();
    const payload = {
      from_name: this.state.name,
      from_email: this.state.email,
      message: this.state.feedback,
      subject: this.state.subject,
    };
    this.setState({loading: true});
      emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, payload, process.env.REACT_APP_PUBLIC_KEY)
      .then(
        (result) => {
          this.setState({loading: false});
          this.setState({
            name: "",
            email: "",
            subject: "",
            feedback: ""
          });
          this.setState({success: true});
          setTimeout(() => {
            this.setState({success: false});
          }, 2000);
          console.log('SUCCESS!', result);
        },
        (error) => {
          this.setState({loading: false});
          this.setState({error: true});
          setTimeout(() => {
            this.setState({error: false});
          }, 2000);
          console.log('FAILED...', error);
        }
      );
  }

  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const message = this.props.data.contactmessage;

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get In Touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="eight columns">
                <fieldset>
                  <div>
                    <label htmlFor="name">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={this.state.name}
                      size="35"
                      id="name"
                      name="name"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="email">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={this.state.email}
                      size="35"
                      id="email"
                      name="email"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      value={this.state.subject}
                      size="35"
                      id="subject"
                      name="subject"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="feedback">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      id="feedback"
                      name="feedback"
                      value={this.state.feedback}
                      onChange={this.handleChange}
                    ></textarea>
                  </div>

                  <div>
                    <button className="submit" onClick={this.handleSubmit}>Submit</button>
                    {this.state.loading && <span id="image-loader">
                      <img alt="" src="images/loader.gif" />
                    </span>}
                  </div>
                </fieldset>

              {this.state.error && <div id="message-warning">Error...!</div>}
              {this.state.success && <div id="message-success">
                <i className="fa fa-check"></i>Your message was sent, thank you!
                <br />
              </div>}
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Address and Phone</h4>
                <p className="address" style={{color: '#ccc'}} >
                  {name}
                  <br />
                  {street} <br />
                  {city}, {state} {zip}
                  <br />
                  <span><a href={`tel: ${phone}`} style={{color: '#ccc', cursor: "pointer"}}>{phone}</a></span>
                  </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Latest Tweets</h4>
                <p>Coming Soon...!</p>
                {/* <ul id="twitter">
                  <li>
                    <span>
                      This is Photoshop's version of Lorem Ipsum. Proin gravida
                      nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
                      quis bibendum auctor, nisi elit consequat ipsum
                      <a href="./">http://t.co/CGIrdxIlI3</a>
                    </span>
                    <b>
                      <a href="./">2 Days Ago</a>
                    </b>
                  </li>
                  <li>
                    <span>
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam, eaque ipsa quae ab illo inventore veritatis et
                      quasi
                      <a href="./">http://t.co/CGIrdxIlI3</a>
                    </span>
                    <b>
                      <a href="./">3 Days Ago</a>
                    </b>
                  </li>
                </ul> */}
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;